import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-6 mb-6" }
const _hoisted_2 = { class: "text-red-500 mt-3 col-span-2 text-center mb-3" }
const _hoisted_3 = { class: "flex-col-reverse flex sm:flex-row sm:items-center gap-4 justify-between" }

import {
		Notification
	} from '@/types'

	// Language
	import {
		useI18n
	} from 'vue-i18n'

	// Types
	import type {
		CustomSong
	} from '@/types'

	// Vue
	import {
		ref
	} from 'vue'
	
	
	const __default__ = { name: 'CustomSongCard' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: [
		'closeModal',
		'saveCustomSong'
	],
  setup(__props, { emit: __emit }) {

	const {t} = useI18n()

	const emit = __emit

	const song = ref<CustomSong>({} as CustomSong)
	const errorMsg = ref('')

	function cancel() {
		emit('closeModal')
	}

	function save() {
		if(!validate()) {
			errorMsg.value = t('customSongModal.errorMsg')
			return
		}
		
		emit('saveCustomSong', song.value)
	}

	function validate() {
		if(!song.value.album?.length) return false
		else if(!song.value.artist?.length) return false
		else if(!song.value.songName?.length) return false
		else if(!song.value.track) return false

		return true
	}


return (_ctx: any,_cache: any) => {
  const _component_tw_input = _resolveComponent("tw-input")!
  const _component_tw_button = _resolveComponent("tw-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", _hoisted_1, [
      _createVNode(_component_tw_input, {
        onInput: _cache[0] || (_cache[0] = () => errorMsg.value = ''),
        modelValue: song.value.songName,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((song.value.songName) = $event)),
        class: "text-md",
        id: "songName",
        label: _unref(t)('customSongModal.songName'),
        required: ""
      }, null, 8, ["modelValue", "label"]),
      _createVNode(_component_tw_input, {
        onInput: _cache[2] || (_cache[2] = () => errorMsg.value = ''),
        modelValue: song.value.artist,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((song.value.artist) = $event)),
        class: "text-md",
        id: "artist",
        label: _unref(t)('customSongModal.artist'),
        required: ""
      }, null, 8, ["modelValue", "label"]),
      _createVNode(_component_tw_input, {
        onInput: _cache[4] || (_cache[4] = () => errorMsg.value = ''),
        modelValue: song.value.album,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((song.value.album) = $event)),
        class: "text-md",
        id: "album",
        label: _unref(t)('customSongModal.album'),
        required: ""
      }, null, 8, ["modelValue", "label"]),
      _createVNode(_component_tw_input, {
        onInput: _cache[6] || (_cache[6] = () => errorMsg.value = ''),
        modelValue: song.value.track,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((song.value.track) = $event)),
        class: "text-md",
        id: "track",
        label: _unref(t)('customSongModal.track'),
        required: ""
      }, null, 8, ["modelValue", "label"])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, _toDisplayString(errorMsg.value), 1)
    ], 512), [
      [_vShow, errorMsg.value]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_tw_button, {
        onClick: cancel,
        class: "w-full"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('songSelection.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_tw_button, {
        onClick: save,
        class: "w-full btn-brand"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('songSelection.save')), 1)
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})